import styled from '@emotion/styled'

export const Box = styled.div`
  display: flex;
  flex-direction: row;
`

export const InputBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`
